import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from 'react/api/actions/stopDetailsPopup';
import ButtonWithDropdown from 'react/components/ButtonWithDropdown';
import { 
  heatMapsIcon,
  heatMapsIconActive
} from 'react/utils/stopDetailsPopupBase64Icons.js';

class HeatMapsButton extends Component {
  
  toggleHeatMaps = () => {
    const { 
      routeId, stopId, heatMapsIsEnabled, 
      enableHeatMapsAction, disableHeatMapsAction 
    } = this.props;
    if (heatMapsIsEnabled) {
      disableHeatMapsAction(routeId, stopId);
    } else {
      enableHeatMapsAction(routeId, stopId);
    }
  }
  
  render() {
    const { heatMapsIsEnabled, styles, ...others } = this.props;
    const { dropdown, ...othersStyles } = styles;

    const dropdownStyle = {
      ...styleButtonDropdownStyle,
      ...dropdown
    }
    return (
      <ButtonWithDropdown
        isActive={heatMapsIsEnabled}
        iconUrl={heatMapsIcon}
        activeIconUrl={heatMapsIconActive}
        label={Monet.I18n.getResourcesByKey('routeDetails.stopDetailsPopup.heatmaps')}
        onClick={this.toggleHeatMaps}
        styles={{dropdown: dropdownStyle, ...othersStyles}}
        {...others}/>
    );
  }
}

const styleButtonDropdownStyle = {
  right: "-46px",
}

HeatMapsButton.propTypes = {
  routeId: PropTypes.oneOfType([ PropTypes.string, PropTypes.number]).isRequired,
  stopId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  heatMapsIsEnabled: PropTypes.bool.isRequired,
  enableHeatMapsAction: PropTypes.func.isRequired,
  disableHeatMapsAction: PropTypes.func.isRequired
}

const mapStateToProps = ({ stopDetailsPopup }, { routeId, stopId }) => ({ 
  heatMapsIsEnabled: stopDetailsPopup.getIn(['actionButtons', String(routeId), String(stopId), 'heatMapsIsEnabled'], false)
});

const mapDispatchToProps = (dispatch) => ({
  enableHeatMapsAction: bindActionCreators(actions.enableHeatMaps, dispatch),
  disableHeatMapsAction: bindActionCreators(actions.disableHeatMaps, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(HeatMapsButton);